/* ✦ Category showcase: hovering/focusing a category row swaps the preview; rotates when idle. */
(function () {
  if (customElements.get('bz-category-showcase')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class BzCategoryShowcase extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('.bz-cshow__row')];
      this.slides = [...this.querySelectorAll('.bz-cshow__slide')];
      this.progress = this.querySelector('[data-bz-cshow-progress]');
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.style.setProperty('--bz-cshow-interval', `${this.interval}ms`);
      if (!this.slides.length) return;

      this.rows.forEach((row, i) => {
        const link = row.querySelector('[data-bz-cshow-link]');
        link.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { this.show(i); this.pause(); } });
        link.addEventListener('focus', () => { this.show(i); this.pause(); });
      });
      this.addEventListener('pointerleave', () => this.resume());
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.resume(); });

      this.canRotate = this.dataset.autoplay === 'true' && !reduceMotion && window.matchMedia('(min-width: 750px)').matches;
      if (this.canRotate && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.visible ? this.resume() : this.pause();
        }, { threshold: 0.35 });
        this.io.observe(this);
      }
    }

    disconnectedCallback() {
      this.pause();
      if (this.io) this.io.disconnect();
    }

    show(i) {
      if (i === this.index) return;
      this.index = i;
      this.rows.forEach((r, k) => r.classList.toggle('is-active', k === i));
      this.slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    restartProgress() {
      this.classList.remove('is-running');
      if (this.progress) void this.progress.offsetWidth;
      this.classList.add('is-running');
    }

    resume() {
      if (!this.canRotate || !this.visible) return;
      clearInterval(this.timer);
      this.restartProgress();
      this.timer = setInterval(() => {
        this.show((this.index + 1) % this.slides.length);
        this.restartProgress();
      }, this.interval);
    }

    pause() {
      clearInterval(this.timer);
      this.classList.remove('is-running');
    }
  }
  customElements.define('bz-category-showcase', BzCategoryShowcase);
})();
